/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />
/// <reference path="./EmployeeClassificationMover.controller.ts" />

module Meevo.Components.Controls {
    'use strict';

    export class EmployeeClassificationMover implements angular.IDirective {
        restrict = 'E';
        templateUrl = 'app/components/controls/employeeClassificationMover/employeeClassificationMover.template.html';
        scope = {
            centralOffice: '=?',
            securityAccess: '=?',
            hierarchyBusinessType: '=?',
            hierarchyId: '=?',
            hierarchyBranchItem: '=?',
            hierarchyLocationList: '=?',
            disabled: '=?',
            filterList: '=?',
            filterFn: '=?',
            isAllSelected: '=?',
        };
        bindToController = true;
        controller = Meevo.Components.Controls.EmployeeClassificationMoverController;
        controllerAs = '$ctrl';
        require = [
            'meevoEmployeeClassificationMover', // self controller
            'ngModel'
        ];
        link = (scope: any, element: JQuery, attr: angular.IAttributes, [self, ngModel]) => {
            self.ngModel = ngModel;
            self.init();
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new EmployeeClassificationMover();
            };

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoEmployeeClassificationMover', EmployeeClassificationMover.factory());
}